import React from 'react';
import { Spin, Icon } from 'antd';
import { ServiceCard } from '../../components';
import { serviceMaps } from './constants';
import { SiteAPI } from '../../requests';
import { useAsync } from '../../hooks';
import weixinEntranceImg from '../../images/weixinEntrance.png'
import './style.less';

interface ServiceItem {
  bizName: string,
  currentCount: number
  bizType: string,
  backendUrl: string
}
const clsPrefix = 'cn-workspace';
const  WorkspaceContainer:React.FC<{}> = () => {
  const { result: services, loading } = useAsync(
    () => SiteAPI.getServices()
  )
  // @ts-ignore
  const openedItems: Array<ServiceItem> = services ? services.openedItems : [];
  // @ts-ignore
  const closedItems: Array<ServiceItem> = services ? services.closedItems : [];

  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />

  return(
    <>
      <div className={clsPrefix}>
        <div style={{
          position: 'fixed',
          right: '10px',
          top: '30%',
          height: '72px',
          width: '200px',
          overflow: 'hidden',
        }}>
          <a href="/v3/weixin/list">
            <img src={weixinEntranceImg} alt="" width="200px" />
          </a>
        </div>
        {
          loading && <Spin indicator={antIcon} size="large" />
        }
        {
          openedItems && !loading && openedItems.length > 0 &&
          <div className={`${clsPrefix}__part`}>
            <div className={`${clsPrefix}__part--title`}>已开通的服务</div>
            <div className={`${clsPrefix}__part--container`}>
              {
                openedItems.map((item:ServiceItem) => (
                  <ServiceCard
                    image={serviceMaps[item.bizType].logo}
                    title={item.bizName}
                    type={item.bizType}
                    unit={serviceMaps[item.bizType].unit}
                    alreadyCount={item.currentCount}
                    isOpen
                    upgradeUrl={serviceMaps[item.bizType].upgrade}
                    link={serviceMaps[item.bizType].link}
                    newVersionUrl={serviceMaps[item.bizType].newVersion}
                  />
                ))
              }
            </div>
          </div>
        }
        {
          closedItems && !loading && closedItems.length > 0 &&
          <div className={`${clsPrefix}__part`}>
            <div className={`${clsPrefix}__part--title`}>更多产品服务</div>
            <div className={`${clsPrefix}__part--container`}>
              {
                closedItems.map((item:ServiceItem) => (
                  <ServiceCard
                    image={serviceMaps[item.bizType].logo}
                    title={item.bizName}
                    type={item.bizType}
                    unit={serviceMaps[item.bizType].unit}
                    desc={serviceMaps[item.bizType].desc}
                    alreadyCount={item.currentCount}
                    upgradeUrl={serviceMaps[item.bizType].upgrade}
                    newVersionUrl={serviceMaps[item.bizType].newVersion}
                    link={serviceMaps[item.bizType].link}
                  />
                ))
              }
            </div>
          </div>
        } 
      </div>
    </>
  )
}

export default WorkspaceContainer;